export const appElement = 'afSearchbar';
